import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const GiftCardImage = ({ className, giftCard }) => {

  const { productImageUrl, giftCardImage } = giftCard;

  if (giftCardImage) {
    return (
      <div className={`gift-card-image-container ${className}`}>
        <img className="gift-card-image" src={giftCardImage} width="320" height="202"/>
      </div>
    );
  }

  return (
    <div className={`gift-card-image-container ${className}`}>
      <div className="product-image-container">
        <img src={productImageUrl}/>
      </div>
    </div>
  );
}


GiftCardImage.propTypes = {
  className: PropTypes.string,
  giftCard: PropTypes.object.isRequired
};

GiftCardImage.defaultProps = {
  className: ''
};

export default GiftCardImage;
